import React from 'react';
import './toggle.scss';


class Toggle extends React.Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {

    let { onChange } = this.props;
    let response = { value: event.target.checked, idItem: this.props.idItem };
    
    if (onChange) {
      onChange(response)
    }
  }

  render() {

    let { check, id } = this.props;
    let { handleChange } = this;

    let value = check || false;

    return (
      <div className="toggleComponent">
        <div className="material-toggle">
          <input id={id} type="checkbox"  checked={ value } onChange={ handleChange } />
          <label htmlFor={id} className="label-color"></label>
        </div>
      </div>
    );
  }
}

export default Toggle;